import { toArray } from "../../lib/functions";
import * as actionTypes from "./actionTypes";

export function getCbtData(resp) {
  return resp?.success ? resp.data : [];
}

export function usersFetched(responseData) {
  return {
    type: actionTypes.CBT_USERS_FETCHED,
    responseData: getCbtData(responseData),
  };
}

export function guestsFetched(responseData) {
  return {
    type: actionTypes.CBT_GUESTS_FETCHED,
    responseData: getCbtData(responseData),
  };
}

export function managersFetched(responseData) {
  return {
    type: actionTypes.CBT_MANAGERS_FETCHED,
    responseData: getCbtData(responseData),
  };
}

export function gradesFetched(responseData) {
  return {
    type: actionTypes.CBT_GRADES_FETCHED,
    responseData: getCbtData(responseData),
  };
}

export function costCentersFetched(responseData) {
  return {
    type: actionTypes.CBT_COST_CENTERS_FETCHED,
    responseData: getCbtData(responseData),
  };
}

export function resetGuestsAndTravellers() {
  return {
    type: actionTypes.CBT_RESET_GUESTS_AND_TRAVELLERS,
  };
}

export function travelReasonsFetched(responseData) {
  return {
    type: actionTypes.CBT_TRAVEL_REASONS_FETCHED,
    responseData: getCbtData(responseData),
  };
}

export function corporateFetched(responseData) {
  return {
    type: actionTypes.CBT_CORPORATE_FETCHED,
    corporate: getCbtData(responseData),
  };
}

export function setCbtPassengersFormHotels(passengersForm) {
  return {
    type: actionTypes.CBT_SET_PASSENGERS_FORM_HOTELS,
    passengersForm,
  };
}

export function cbtPassengersFormParamsFromQuery(query, isHotels = false) {
  if (!query) {
    return null;
  }

  const {
    userIds,
    guests,
    flightClass,
    costCenterId,
    travelReasonId,
    guestsGradeIds,
    policyResolvedId,
    hotelIndicator,
  } = query;
  if (!costCenterId || !travelReasonId) return null;

  const parsedHotelRoomAssignments = {};
  if (isHotels) {
    Object.keys(query).forEach((key) => {
      const match = key.match(/^room_(\d+)_travellers$/);
      if (match) {
        const roomIndex = match[1];
        const value = query[key];
        parsedHotelRoomAssignments[roomIndex] = Array.isArray(value)
          ? value.map(String)
          : [String(value)];
      }
    });
  }

  const newPassengerFormFromQuery = {
    travellers: userIds ? toArray(userIds) : [],
    guests: Number(guests ?? 0),
    flightClass,
    guestsGradeIds: guestsGradeIds ? toArray(guestsGradeIds) : [],
    costCenter: costCenterId,
    hotelRoomAssignments: isHotels ? parsedHotelRoomAssignments : {},
    hotelRoomAssignmentsBookingProcess: isHotels
      ? parsedHotelRoomAssignments
      : {},
    travelReason: travelReasonId,
    policyResolvedId,
    ...(isHotels && hotelIndicator
      ? {
          hotelIndicator: Array.isArray(hotelIndicator)
            ? hotelIndicator[0]
            : hotelIndicator,
        }
      : {}),
  };

  return newPassengerFormFromQuery;
}

export function initPassengerForm(query) {
  return {
    type: actionTypes.CBT_INIT_FROM_URL,
    passengersForm: cbtPassengersFormParamsFromQuery(query),
  };
}

export function incrementGuests(id = null) {
  return {
    type: actionTypes.CBT_INCREMENT_GUESTS,
    id,
  };
}

export function decrementGuests(id = null) {
  return {
    type: actionTypes.CBT_DECREMENT_GUESTS,
    id,
  };
}

export function syncGuestsFromSearchPassengers(searchPassengers) {
  return {
    type: actionTypes.CBT_SYNC_GUESTS_FROM_SEARCH_PASSENGERS_MOBILE,
    searchPassengers,
  };
}

export function changeFlightClass(flightClass) {
  return {
    type: actionTypes.CBT_CHANGE_FLIGHT_CLASS,
    flightClass,
  };
}

export function changeCostCenter(costCenter) {
  return {
    type: actionTypes.CBT_CHANGE_COST_CENTER,
    costCenter,
  };
}

export function changeTravelReason(travelReason) {
  return {
    type: actionTypes.CBT_CHANGE_TRAVEL_REASON,
    travelReason,
  };
}

export function addTraveller(traveller) {
  if (!traveller) {
    return { type: actionTypes.NULL_ACTION };
  }

  return {
    type: actionTypes.CBT_ADD_TRAVELLER,
    traveller,
  };
}

export function addTravelerHotels(roomAssignments) {
  if (!roomAssignments) {
    return { type: actionTypes.NULL_ACTION };
  }

  return {
    type: actionTypes.CBT_ADD_TRAVELER_HOTELS,
    roomAssignments,
  };
}

export function removeTraveller(traveller) {
  return {
    type: actionTypes.CBT_REMOVE_TRAVELLER,
    traveller,
  };
}

export function removeTravelerHotels(traveler) {
  return {
    type: actionTypes.CBT_REMOVE_TRAVELER_HOTELS,
    traveler,
  };
}

export function resetTravelerHotels() {
  return {
    type: actionTypes.CBT_RESET_TRAVELER_HOTELS,
  };
}

export function setPolicyResolvedId(id) {
  return {
    type: actionTypes.SET_CBT_POLICY_RESOLVED_ID,
    data: { name: "policyResolvedId", value: id },
  };
}

export function clearErrors() {
  return {
    type: actionTypes.CBT_PASSENGER_FORM_CLEAR_ERRORS,
  };
}

export function closeForm() {
  return {
    type: actionTypes.CBT_CLOSE_PASSENGERS_FORM,
  };
}

export const setCbtValue = (name, value) => {
  return {
    type: actionTypes.SET_CBT_VALUE,
    data: { name, value },
  };
};
